export { PLUGIN_KEY, PLUGIN_PRIORITY, CustomBorders } from "./customBorders.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/customBorders/index.mjs
// module id = 1342
// module chunks = 1